import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col } from "antd";
import "./Firmpartner.css";
import ScheduleUsers from "../SubtenantUsers/SubtenantUsers";
import SubtenantTable from "../SubtenantUsers/SubtenantTable";
import SearchByEmail from "../KnowYourUser/KnowYourUser";
import Subtents from "./Subtents";
import SchedulePlanner from "./SchedulePlanner";
import SchedulePlanner2 from "./SchedulePlanner2";
import konsole from "../../network/konsole";
import ParentCabinet from "../newFileCabinet/ParentCabinet";
import Compensation from "./Compensation";

const Menubtns = (props) => {
  const routeLocation = useLocation();
  const [change, setChange] = useState(false);
  const [addbeneficiriesshow, setaddbeneficiries] = useState(false);
  const [addbenefiiriespropstype, setaddbeneficiriestype] = useState("");
  const [changeBorder, setChangeBorder] = useState(1);
  const [number, setNumber] = useState(null);
  const [roleid, setroleid] = useState('')

  //   const managebeneficiries = () => {
  //     setaddbeneficiries(true)
  //     konsole.log("1")
  //     setChange(false)
  //   }

  useEffect(() => {
    let userroleId = JSON.parse(sessionStorage.getItem("stateObj"))
    setroleid(userroleId?.roleId)
    setNumber(1)
    konsole.log("roleidid", userroleId?.roleId)
  }, [])
  useEffect(() => {
    const searchParams = new URLSearchParams(routeLocation.search)
    let userroleId = JSON.parse(sessionStorage.getItem("stateObj"))
    const viewValue = searchParams.get('view')
    let viewValueNum = viewValue == null ? 1 : viewValue
    setNumber(viewValueNum)
    if(typeof props?.setsubscriptionbtn === 'function'){
      const viewValueOfPage = viewValueNum;
      props?.setsubscriptionbtn(viewValueOfPage)
    }
  }, [routeLocation.search])

  //   const AddBeneficiries = (addbeneficiries) => {
  //     setaddbeneficiriestype(addbeneficiries)
  //     setaddbeneficiries(false)
  // konsole.log("2")
  //     setChange(false)

  //   }

  //   const SchedulePlanner = (addbeneficiries)=>{
  //     setaddbeneficiriestype(addbeneficiries)
  //     setaddbeneficiries(true)
  // konsole.log("3")
  //     setChange(false)
  //   }

  const managebeneficiries = (num) => {
    setNumber(num);
    sessionStorage.setItem("partAdminSubtenant", '');
    const newURL = window.location.origin + window.location.pathname + `?view=${num}`
    window.history.pushState({ path: newURL }, '', newURL);


    // switch (number) {
    //   case 1:
    //     break;
    //   case 2:
    //     break;
    //   default:
    // }
  };

  const manageSubscriptionPages = (num) =>{
    props?.setsubscriptionbtn(num);
    const newURL = window.location.origin + window.location.pathname + `?view=${num}`
    window.history.pushState({ path: newURL }, '', newURL);
  }

  return (
    <div className="row d-flex justify-content-between subsmainDiv" style={{borderBottom:"1px solid #ddd", margin:" 0px 0px"}}>

      {(props?.screenType == 'subscriptionbtns') ? <div className="col-sm-9 subs2Div ">
        {props?.subscriptionbtn == 1 &&<div  onClick={() => manageSubscriptionPages(1)}>
        {/* {(props?.subscriptionbtn == 1) ? <img src= "/images/package2Img.svg"/> : <img src= "/images/packageImg.svg"/>} */}

        <button
          className={`${(props?.subscriptionbtn == 1) ? "schedule-active" : ""} me-2 schedule`}

        >
          Product Management
        </button>
        </div>}

        {roleid == 4 && <div className="d-flex">
        {props?.subscriptionbtn == 2 &&<div  onClick={() => manageSubscriptionPages(2)}>
          {(props?.subscriptionbtn == 2) ? <img src= "/images/rateCardimage.svg"/> : <img src= "/images/rateCard2Img.svg"/>}
        <button
          className={`${(props?.subscriptionbtn == 2) ? "schedule-active" : ""} me-2 schedule  fw-bold  border-gray`}

        >
          Pricing
        </button>
        </div>}
        {/* <div className="ms-4">
        <button
          className={`${(props?.subscriptionbtn == 3) ? "schedule-active" : ""} me-2 schedule  fw-bold  border-gray`}
          onClick={() => props?.setsubscriptionbtn(3)}
        >
          Discount
        </button>
        </div> */}
          </div>}
        {/* <button
            className={`${(props?.subscriptionbtn == 4) ? "schedule-active" : ""} me-2 schedule  fw-bold  border-gray`}
            onClick={()=>props?.setsubscriptionbtn(4)}
          >
            Billing
          </button>
          <button
            className={`${(props?.subscriptionbtn == 5) ? "schedule-active" : ""} me-2 schedule  fw-bold  border-gray`}
            onClick={()=>props?.setsubscriptionbtn(5)}
          >
            Mis Report
          </button> */}
      </div>
        : <>
          <div className="col-12 d-flex ps-0 ms-0 " style={{ paddingTop: "8px" ,borderBottom:"1px solid #474747"}} >

            {(roleid !== "11" && number == 1) ?

              <button
                className={
                  number == 1
                    ? "schedule-active me-2 schedule  fw-bold  border-gray ps-0"
                    : "me-2 schedule  fw-bold  border-gray ps-0"
                }
                onClick={() => managebeneficiries(1)}
              >

                Firms
              </button> : null
            }

           {number == 2 && <button
              className={
                number == 2
                  ? "schedule-active me-2 schedule  fw-bold  border-gray ps-0"
                  : "me-2 schedule  fw-bold  border-gray ps-0"
              }
              onClick={() => managebeneficiries(2)}
            >

              {(roleid == 4)? 'Firm Users':'Staff Members'}
            </button>}

           {number == 3 && <button
              className={
                number == 3
                  ? "schedule-active me-2 schedule  fw-bold  border-gray ps-0"
                  : "me-2 schedule  fw-bold  border-gray ps-0"
              }
              onClick={() => managebeneficiries(3)}
            >
              Schedule Planner
            </button>}



            {number == 9 && <button style={{marginBottom:"5px"}} className={number == 9 ? "schedule-active me-2 schedule  fw-bold  ps-0"
              : "me-2 schedule  fw-bold"} onClick={() => managebeneficiries(9)}>
              Compensation Configuration</button>}


            {roleid == 4 && number == 6 && <button
              className={
                number == 6
                  ? "schedule-active me-2 schedule  fw-bold  border-gray ps-0"
                  : "me-2 schedule  fw-bold  border-gray ps-0"
              }
              onClick={() => managebeneficiries(6)}
            >
              Know Your User
            </button>}

            {roleid == 4 && number == 7 && <button
              className={
                number == 7 ? "schedule-active me-2 schedule  fw-bold  border-gray ps-0" : "me-2 schedule  fw-bold  border-gray ps-0"}
              onClick={() => managebeneficiries(7)}
            >
              File Cabinet
            </button>}
          </div>
          <div style={{ paddingRight: "0px",paddingLeft:"0px" }}>
            {number == 1 ? <Subtents/> :
             number == 2 ? <SubtenantTable /> :
             number == 6 ? roleid == 4 && <SearchByEmail /> :
             number == 7 ? <ParentCabinet belongsScreen='Firmpartner' /> :
             number == 9 ? <Compensation/> :
             <SchedulePlanner2 setNumber={setNumber}
              />
            }
          </div>
        </>}
    </div>
  );
};

export default Menubtns;
